import { z } from "zod";

export enum TravelPurpose {
  BUSINESS = "Business",
  LEISURE = "Leisure",
}

export const TravelPurposeSchema = z.nativeEnum(TravelPurpose);
